/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit";
import { resendDatasetEmail } from "../actions/transactionLogs.action";

const initialState: any = {};

const resendDatasetEmailSlice = createSlice({
  name: "Resend Dataset Email",
  initialState,
  reducers: {
    resetResendStatus(state) {
      state.data = null;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resendDatasetEmail.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(resendDatasetEmail.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(resendDatasetEmail.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export const { resetResendStatus } = resendDatasetEmailSlice.actions;
export default resendDatasetEmailSlice.reducer;
